import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';
import { ConfigService } from '../../config/config.service';
import { TaskGridSavedFilter } from './definitions/task-grid-saved-filter.interface';

@Injectable()
export class GetUserDefaultFilters {
  private apiUrl: string = this.configService.config.rest.apiV2Url;

  constructor(
    private client: HttpClient,
    private configService: ConfigService
  ) {}

  public getDefaultFilters(): Observable<TaskGridSavedFilter> {
    const url = `${this.apiUrl}/me/settings/task-grid/default-filter`;
    return this.client
      .get<TaskGridSavedFilter>(url)
      .pipe(
        catchError((error) => throwError(() => handleProblem(error)))
      );
  }
}
